import { type FC } from 'react';

type Photo40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Photo40: FC<Photo40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
            viewBox="0 0 40 40"
        >
            <path d="M7.778 35C7.028 35 6.377 34.725 5.826 34.174C5.275 33.623 5 32.972 5 32.222V7.778C5 7.028 5.275 6.377 5.826 5.826C6.377 5.275 7.028 5 7.778 5H32.222C32.972 5 33.623 5.275 34.174 5.826C34.725 6.377 35 7.028 35 7.778V32.222C35 32.972 34.725 33.623 34.174 34.174C33.623 34.725 32.972 35 32.222 35H7.778ZM7.778 32.222H32.222V7.778H7.778V32.222ZM9.889 28.417H30.139L23.972 20.195L18.639 27.167L14.805 21.972L9.889 28.417Z" />
        </svg>
    );
};

export default Photo40;
